<template>
  <v-container>
    <div
      class="display-2 mb-7 mt-5 font-weight-thin"
      color="primary"
    >{{$tc('entities.report.title',2)}}</div>
    <alert-box v-model="alert.alerts" :type="alert.type"></alert-box>

    <btn-a v-if="!noAction" rounded color="primary" @click="editItem" :access="$access.report.edit">
      <v-icon>mdi-plus</v-icon>
    </btn-a>

    <table-grid
      :noAction="noAction"
      :multiple="multiple"
      :singleSelect="singleSelect"
      :headers="headers"
      :items="items"
      :loading="loadingTable"
      :loadingAction="loadingDialog"
      :actions="actions"
      :page="pagination.page"
      :pageLength="lengthPaginationComp"
      @input="pagination.page = $event"
      @click="clickTable($event)"
      @search="searchTable"
    />

    <dialog-d
      ref="dialogEdit"
      :title="$tc('entities.report.title',1)"
      :deleteButton="itemSelected && itemSelected.id"
      @confirm="saveItem(itemSelected,$refs.form.isValid())"
      @delete="deleteItem(itemSelected,true)"
      :loading="loadingDialog"
      :alert="form.alert"
      :accessConfirm="$access.report.edit"
      :accessDelete="$access.report.delete"
    >
      <report-form v-if="itemSelected" ref="form" v-model="itemSelected" />
    </dialog-d>
  </v-container>
</template>

<script>
import reportService from "@/services/reportService";
import pageListMixing from "../mixins/pageLists/pageListMixing.js";
import reportForm from "../components/forms/reports/reportForm";
export default {
  props: {},
  mixins: [pageListMixing],
  components: { reportForm },

  data() {
    return {
      entityService: reportService,
      apiController: "item",
      searchFields: ["description"],
      headers: [
        {
          text: this.$t("entities.report.props.description"),
          align: "left",
          sortable: false,
          value: "description",
        },
        {
          text: this.$t("entities.report.props.description"),
          align: "left",
          sortable: false,
          value: "description",
        },

        {
          text: this.$t("table.actions"),
          value: "action",
          sortable: false,
          align: "right",
        },
      ],
      actions: [
        {
          text: this.$t("edit"),
          icon: "mdi-pencil",
          handle: this.editItem,
          access: [this.$access.report.edit, this.$access.report.show],
        },
        {
          text: this.$t("delete"),
          icon: "mdi-delete",
          handle: this.deleteItem,
          access: this.$access.report.delete,
        },
      ],
    };
  },
  methods: {
    save() {
      console.log(this.$refs.form);
      this.saveItem(this.itemSelected, true);
    },
    async getModelDefault() {
      return {
        description: "",
        query: "",
        font: "",
        params: [],
        customFields: [],
      };
    },
  },
  async mounted() {
    await this.getItems();
  },
};
</script>